'use strict';

var defineProperty = require('../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var ObjectHelper = require('../common/ObjectHelper.js');
var grey = require('../node_modules/@material-ui/core/esm/colors/grey.js');
var TextField$1 = require('../node_modules/@material-ui/core/esm/TextField/TextField.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var TextField = function TextField(_ref) {
  var InputProps = _ref.InputProps,
      _ref$inputProps = _ref.inputProps,
      inputProps = _ref$inputProps === void 0 ? {} : _ref$inputProps,
      dataTestId = _ref["data-testid"],
      variant = _ref.variant,
      props = objectWithoutProperties(_ref, ["InputProps", "inputProps", "data-testid", "variant"]);

  var style = InputProps.style;
  var newStyle = {};

  if (ObjectHelper.isPresent(style)) {
    newStyle = _objectSpread({}, style);
  }

  if (variant === 'filled') {
    newStyle.backgroundColor = grey[100];
  }

  return React__default["default"].createElement(TextField$1["default"], _objectSpread({
    variant: variant,
    InputProps: _objectSpread({}, InputProps, {
      style: newStyle
    }),
    inputProps: _objectSpread({}, inputProps, {
      "data-testid": dataTestId
    })
  }, props));
};

TextField.defaultProps = {
  InputProps: {
    style: {}
  },
  variant: 'filled'
};

module.exports = TextField;
